module.exports = __webpack_public_path__ + "static/media/Referandearn.cb15641e.png";